import { AvailabilityEnum } from '../../../modules/products/ProductTypes';
import { BusinessPolicyType } from './businessPolicies.types';
import { BusinessPolicyConditionNodeDTO } from './businessPolicyCondition.types';

export enum BusinessPolicyNodeOutcome {
  SATISFIED = 'SATISFIED',
  NOT_SATISFIED = 'NOT_SATISFIED',
  IGNORED = 'IGNORED',
}

export interface BusinessPolicyViolationPolicyDTO {
  id: string;
  name: string;
  type: BusinessPolicyType;
}

export interface BusinessPolicyGroupResultDTO {
  productColorId: string;
  productColorCode: string;
  availability?: AvailabilityEnum;
  deliveryWindowId?: string;
  deliveryWindowName?: string;
  expected: number;
  reached: number;
  satisfied: boolean;
}

export interface BusinessPolicyNodeEvaluationDTO {
  nodeId: string;
  outcome: BusinessPolicyNodeOutcome;
  expected?: number | null;
  reached?: number | null;
  groups?: BusinessPolicyGroupResultDTO[];
}

export interface BusinessPolicyViolationRewardDTO {
  position: number;
  condition: BusinessPolicyConditionNodeDTO;
}

export interface BusinessPolicyViolationDTO {
  businessPolicy: BusinessPolicyViolationPolicyDTO;
  rewards: BusinessPolicyViolationRewardDTO[];
  evaluation: { nodes: BusinessPolicyNodeEvaluationDTO[] };
}
